import isEmpty from 'lodash/isEmpty';

import { FilterOptionModel, QueryParamModel } from 'models';
import { parse } from 'utils/base64';

export function isMockMode(): boolean {
  return import.meta.env.MODE === 'mock';
}

export function isListEnabled(params?: QueryParamModel | null): boolean {
  return !!params?.filter || isMockMode();
}

// Chip deletion bypasses the Yup validation of the filter panel, so the list query has to be
// gated separately, otherwise an incomplete filter is sent and the 400 toast hides the warning.
export function hasRequiredFilterValues(
  params?: QueryParamModel | null,
  filters?: FilterOptionModel[] | string[]
): boolean {
  const activeFilter = parse<Record<string, unknown>>(params?.filter);
  const requiredNames = (filters || [])
    .map((filter) =>
      typeof filter === 'string' ? filter : (filter.filterIsRequired && filter.name) || ''
    )
    .filter(Boolean);

  return requiredNames.every((name) => {
    const value = activeFilter[`${name}`];

    return typeof value === 'number' || typeof value === 'boolean' || !isEmpty(value);
  });
}

export function getListParams<T extends QueryParamModel | null | undefined>(
  params: T,
  requiredFilters?: FilterOptionModel[] | string[]
): T | null {
  return hasRequiredFilterValues(params, requiredFilters) ? params : null;
}
